import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getKonkurBookletPdfsService = async (
  userToken: string,
  params: { categoryId: string | number },
) => {
  return axiosV4.get(`/user/konkur-booklets/pdfs?konkur_booklet_category_id=${params.categoryId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
